export default {
	clubGroupChecked(state) {
		return state.formGroups.clubGroup.checkboxes.filter(checkbox => checkbox.isChecked);
	},
	grassrootsGroupChecked(state) {
		return state.formGroups.grassrootsGroup.checkboxes.filter(checkbox => checkbox.isChecked);
	},
	leagueGroupChecked(state) {
		return state.formGroups.leagueGroup.checkboxes.filter(checkbox => checkbox.isChecked);
	},
	priorityTicketingIsChecked(state) {
        return state.formGroups.priorityTicketing.checkboxes[0].isChecked;
    },
    priorityTicketingChecked(state) {
        return state.formGroups.priorityTicketing.checkboxes.filter(checkbox => checkbox.isChecked);
    },
	checkboxGroupChecked(state) {
		return state.formGroups.checkboxGroup.checkboxes.filter(checkbox => checkbox.isChecked);
	},
    disableGroupChecked(state) {
        return state.formGroups.disableGroup.checkboxes.filter(checkbox => checkbox.isChecked);
    },
	offerGroupChecked(state) {
		return state.formGroups.offerGroup.checkboxes.filter(checkbox => checkbox.isChecked);
	},
	optinGroupChecked(state) {
		return state.formGroups.optinGroup.checkboxes.filter(checkbox => checkbox.isChecked);
	},
	subscribedToFanOffer(state) {
		return state.optInFanOffer || !!JSON.parse(localStorage.getItem('optInFanOffer'))
	}
};
